import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgArrowBack({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12.02v-.04a1.005 1.005 0 01.011-.129l.01-.052a.951.951 0 01.125-.32l.05-.074.01-.013a1.01 1.01 0 01.087-.1l-.08.091.03-.036-.03.036a.998.998 0 01.08-.09l9-9a1 1 0 011.498 1.32l-.083.094L5.413 11H21a1 1 0 01.993.883L22 12a1 1 0 01-.883.993L21 13H5.414l7.294 7.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.415 0l-9-9a1.004 1.004 0 01-.282-.559l-.008-.066-.001-.023v-.005L2 12.019zm.293-.727a.998.998 0 00-.097.112l.028-.035.069-.077z"
        fill={color}
      />
    </svg>
  )
}

export default SvgArrowBack
